/*
  Shoppable slideshow hotspots (sections/popsy-shoppable-slideshow.liquid).

  The slideshow itself is the stock theme.SlideshowSection; this file only adds what
  hotspots need on top of it:

  - Quick shop. On desktop, "View product" opens the quick shop modal, and the
    product is fetched on first hover of the pin. On mobile it is a normal link.
    This is the same logic as KitShoppableHero in sections/shoppable-hero.liquid.
  - Autoplay pauses while a product card is open and resumes when it closes, so
    the slide does not fade out from under the card. Changing slide (dots, swipe)
    and scrolling close any open card, as the stock section does on scroll.
  - Editor: selecting a hotspot block opens its card. The stock JS has already
    gone to its slide, because the slide carries the hotspot's block id as a class.

  Everything is delegated from document, so it keeps working when the editor
  re-renders the section.
*/
(function () {
  var ROOT = '[data-popsy-shoppable]';

  function flickityFor(el) {
    var root = el.closest(ROOT);
    var slideshow = root && root.querySelector('.hero');
    return slideshow && window.Flickity && window.Flickity.data(slideshow);
  }

  function closeAll(root) {
    (root || document).querySelectorAll(ROOT + ' kit-popover:popover-open').forEach(function (p) {
      p.hidePopover();
    });
  }

  // Close cards when the slide changes. Bound lazily, because Flickity only exists
  // once the section has been seen, which a card being opened guarantees.
  function bindSlideChange(flkty, root) {
    if (!flkty || flkty.popsyHotspotsBound) return;
    flkty.popsyHotspotsBound = true;
    flkty.on('change', function () { closeAll(root); });
  }

  // 'toggle' does not bubble, so listen in the capture phase.
  document.addEventListener('toggle', function (event) {
    var popover = event.target;
    if (!popover.matches || !popover.matches(ROOT + ' kit-popover')) return;

    var flkty = flickityFor(popover);
    if (!flkty) return;
    bindSlideChange(flkty, popover.closest(ROOT));

    if (event.newState === 'open') {
      flkty.pausePlayer();
    } else if (!document.querySelector(ROOT + ' kit-popover:popover-open')) {
      flkty.unpausePlayer();
    }
  }, true);

  window.addEventListener('scroll', function () { closeAll(); }, { passive: true });

  function initQuickShop() {
    if (!window.theme || !theme.settings || !theme.settings.quickView) return;

    document.querySelectorAll(ROOT + ' .shoppable-hero__popover-link[data-product-handle]').forEach(function (link) {
      if (link.dataset.shoppableHeroBound === 'true') return;
      link.dataset.shoppableHeroBound = 'true';

      var handle = link.dataset.productHandle;
      var productId = link.dataset.productId;
      var sectionEl = link.closest('[id^="shopify-section-"]');

      if (!document.getElementById('QuickShopModal-' + productId)) return;

      // Capture phase, so it runs before the modal's own handler. On mobile it stops
      // that handler and lets the link navigate.
      link.addEventListener('click', function (event) {
        if (theme.config.bpSmall) {
          event.stopImmediatePropagation();
          return;
        }
        var popover = event.target.closest('kit-popover');
        if (popover) popover.hidePopover();
      }, true);

      var hotspot = link.closest('.popsy-hotspot');
      if (!hotspot) return;

      var preloadOnce = function () {
        if (link.dataset.shoppableHeroPreloaded === 'true') return;
        if (theme.config.bpSmall) return;

        // Another section (a product grid, say) may already hold this product's
        // modal. Drop our copy of the shell so the ids are not duplicated.
        var holder = document.getElementById('QuickShopHolder-' + handle);
        if (holder && sectionEl) {
          var holderSection = holder.closest('[id^="shopify-section-"]');
          if (holderSection && holderSection !== sectionEl) {
            var duplicate = sectionEl.querySelector('#QuickShopModal-' + productId);
            if (duplicate) duplicate.remove();
          }
        }

        link.dataset.shoppableHeroPreloaded = 'true';
        link.classList.add('js-modal-open-quick-modal-' + productId);
        theme.preloadProductModal(handle, productId, link);

        hotspot.removeEventListener('mouseover', preloadOnce);
        hotspot.removeEventListener('focusin', preloadOnce);
      };

      hotspot.addEventListener('mouseover', preloadOnce);
      hotspot.addEventListener('focusin', preloadOnce);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initQuickShop);
  } else {
    initQuickShop();
  }

  if (!window.Shopify || !Shopify.designMode) return;

  document.addEventListener('shopify:section:load', function (event) {
    if (event.target.querySelector(ROOT)) initQuickShop();
  });

  document.addEventListener('shopify:block:select', function (event) {
    var hotspot = event.target.closest && event.target.closest(ROOT + ' .popsy-hotspot');
    if (!hotspot) return;
    initQuickShop();
    // Let the stock JS finish fading to the slide, so the card is placed against
    // the pin where it ends up.
    setTimeout(function () {
      var popover = hotspot.querySelector('kit-popover');
      if (popover && !popover.matches(':popover-open')) popover.showPopover();
    }, 400);
  });

  document.addEventListener('shopify:block:deselect', function (event) {
    var popover = event.target.querySelector && event.target.querySelector(ROOT + ' kit-popover');
    if (popover && popover.matches(':popover-open')) popover.hidePopover();
  });
})();
